// import axios from 'axios';
import { req ,getByobj,postByobj, exportExcel} from './axiosFun';


// 获取云仓数据
export const commoditySyncList = (params) => { return getByobj("get", "/commoditySync/listByPage", params) };
// 同步云仓数据
export const commoditySync = (params) => { return req("post", "/commoditySync/synchronization",params) };

// 洋葱
// 同步到中间表
export const goodsUpdateOrInsert = (params) => { return req("post", "/commoditySync/synchronization/yangCoong/goodsUpdateOrInsert",params) };
// 同步到本地商品
export const synchronization = (params) => { return req("post", "/commoditySync/synchronization/yangCong",params) };
// 已同步数据更新
export const synchronizationUpdate = (params) => { return req("post", "/commoditySync/synchronization/yangCong/update",params) };

// 云仓商品信息导出
export const exportCloudStore = (params) => { return exportExcel("get", "/commoditySync/export",params) };

//云仓数据 商品分类查询
export const getThirdClassificationType = (params) => { return getByobj("get", "/commoditySync/getThirdClassificationType", params) };
//云仓选择字段更新
export const CommodityChoseUpdate = (params) => { return req("post", "/commoditySync/synchronization/CommodityChoseUpdate",params) };



// WEBPACK FOOTER //
// ./src/api/cloudStore.js